// extracted by mini-css-extract-plugin
export default {"bold":"RTFBold_bold__8Q+Jd"};